import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field mt-2" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "p-field-label mt-3" }
const _hoisted_4 = { class: "p-field mt-3" }
const _hoisted_5 = { class: "p-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_HourPicker = _resolveComponent("HourPicker")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.FromTime")), 1),
        _withDirectives(_createVNode(_component_Button, {
          label: _ctx.$t('AppResource.Remove'),
          class: "ml-auto p-button-text mr-2",
          onClick: _ctx.handleTimeSlotRemove
        }, null, 8, ["label", "onClick"]), [
          [_vShow, _ctx.timesSlotslength !== 1]
        ])
      ]),
      _createVNode(_component_HourPicker, {
        modelValue: _ctx.since,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.since = $event)),
          _ctx.updateSince
        ],
        disabled: _ctx.disabled,
        width: _ctx.isEdit ? 'w-50' : 'w-100'
      }, null, 8, ["modelValue", "disabled", "width", "onUpdate:modelValue"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.ToTime")), 1),
      _createVNode(_component_HourPicker, {
        modelValue: _ctx.until,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => (_ctx.until = $event)),
          _ctx.updateUntil
        ],
        disabled: _ctx.disabled,
        width: _ctx.isEdit ? 'w-50' : 'w-100',
        inputError: !_ctx.timeValid()
      }, null, 8, ["modelValue", "disabled", "width", "inputError", "onUpdate:modelValue"])
    ])
  ], 64))
}